const FalsePromise = () => {
  const promise = new Promise((resolve, reject) => resolve(false));
  return promise;
};

export default FalsePromise;
